import { useState } from 'react'
import Checkbox from '@mui/material/Checkbox'
import { useDatasetDataContext } from '@datasets/dataset-details/datasetData/context'
import { DisabledPopover } from './DisabledPopover'
import { SELECTION_LIMIT_MSG } from '../ReadGridConstants'

export function ReadGridRowSelectCell({
  parent,
  rowIndex,
  style,
  isDisabled,
  isHeaderSelected,
  isCheckboxDisabled,
}) {
  const { selectedRows } = useDatasetDataContext()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  function handlePopoverOpen(e) {
    setAnchorEl(e.currentTarget)
  }

  function handlePopoverClose() {
    setAnchorEl(null)
  }

  return (
    <div className="read-grid-cell row-num-cell" style={style}>
      <div onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        <Checkbox
          disabled={isDisabled || isCheckboxDisabled}
          checked={!!selectedRows[rowIndex] || isHeaderSelected}
          onChange={() => parent.props.handleSelect(rowIndex)}
          inputProps={{
            'aria-label': 'primary checkbox',
          }}
        />
      </div>
      {isCheckboxDisabled && (
        <DisabledPopover anchorEl={anchorEl} open={open} handlePopoverClose={handlePopoverClose}>
          <div>{SELECTION_LIMIT_MSG}</div>
        </DisabledPopover>
      )}
    </div>
  )
}
